import React, {useContext, useEffect, useLayoutEffect, useRef, useState} from "react";
import {Typography} from "antd";
import {observer} from "mobx-react";
import {Button, LionProgressbar} from "@bezlimit/bezlimit-ui";

import _ from "lodash";
import "./style.scss";
// images
import LogoSVG from "@/images/logo1.svg";
import {useLocation, useNavigate, useParams, useSearchParams} from "react-router-dom";
import {ModalContext} from "../../../../../core/Contexts";
import useResize from "../../../../../core/hooks/useResize";
import {axiosFetchBuilder} from "../../../../../core/Axios";
import axios from "axios";
import Store from "../../../../../stores";
// core
// import useResize from "@/core/hooks/useResize";
// import {ModalContext} from "@/core/Contexts";
// import {axiosFetchBuilder} from "@/core/Axios";
// components
import Error from "../../../../modal/error";
import SuccessAddPassport from "../../../../modal/successAddPassport";
import {serialize} from "object-to-formdata";
import ErrorPassportAdd from "../../../../modal/errorPassportAdd";
import ReservationsService from "../../../../../services/ReservationsService";

const SignaturePad = require("signature_pad");
const SignaturePadResult = require("signature_pad");
const options = {
    backgroundColor: "transparent",
    penColor: "rgb(0, 85, 255)"
};

const Sign: React.FC = observer(() => {
    const ref = useRef<any>(null);
    const refResult = useRef<any>(null);
    const timeout = useRef<NodeJS.Timeout>();
    const [signaturePad, setSignaturePad] = useState<any>();
    const [response, setResponse] = useState<any>();
    const [isLoaded, setIsLoaded] = useState(false);
    const [loading, setLoading] = useState(false);
    const [value, setValue] = useState(0);
    const {width} = useResize();
    const contextModal = useContext(ModalContext);
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const [phoneInfo, setPhoneInfo] = useState<any>();

    const onClear = () => {
        signaturePad.clear();
    };

    const save = (src: string, fileName: string, mimeType: string) => {
        return fetch(src)
            .then((res) => {
                return res.arrayBuffer();
            })
            .then(async (buf) => {
                try {
                    const signature = new File([buf], fileName, {type: mimeType});

                    // await axiosFetchBuilder({
                    //     baseURL: process.env.REACT_APP_SITE_API_URL,
                    //     url: `/documents/signature/${params?.token}`,
                    //     method: "POST",
                    //     data: {signature},
                    //     headers: {
                    //         skip: "1",
                    //         Authorization: process.env.REACT_APP_SITE_BASIC_AUTH_HEADER!
                    //     }
                    // });

                    const res = await axiosFetchBuilder({
                        url: "/reservations/signature",
                        method: "POST",
                        data: {
                            phone: searchParams.get("phone"),
                            file: signature
                        },
                        loading: false
                    });

                    setResponse({value: true});
                    setValue(100);
                } catch (e) {
                    setResponse({value: false});
                } finally {
                    clearTimeout(timeout.current);
                    setIsLoaded(true);
                }
            });
    };

    const onClick = async () => {
        if (signaturePad.isEmpty()) {
            contextModal?.setChildren(
                <Error title="Пожалуйста, сначала поставьте свою подпись." />
            );
            contextModal?.setVisible(true);
        } else {
            clearTimeout(timeout.current);
            setLoading(true);
            let i = 0;
            let updated = 0;

            const loop = async () => {
                do {
                    ++i;
                    updated += 2;
                } while (i == i + 1);

                if (i && updated <= 100) {
                    setValue(updated);
                    timeout.current = setTimeout(loop, 100);
                } else {
                    setIsLoaded(true);
                }
            };

            loop();
        }
    };

    const onCancel = () => {
        contextModal?.setVisible(false);
    };

    const resize = () => {
        if (ref.current && signaturePad) {
            const parent = ref.current.closest(".sign");
            ref.current.width = parent.clientWidth > 884 ? 884 : parent.clientWidth;
            ref.current.height =
                width > 992
                    ? 439
                    : width < 576
                    ? document.documentElement.clientHeight - 411
                    : document.documentElement.clientHeight - 532;
            ref.current.getContext("2d").scale(1, 1);
            signaturePad.clear();
        }
    };

    const onCancelSign = () => {
        contextModal?.setMaskStyle(undefined);
        contextModal?.setCssClass("");
        contextModal?.setVisible(false);
        navigate(`/reservation`);
    };

    useEffect(() => {
        if (isLoaded && !_.isNil(response?.value)) {
            if (response?.value) {
                contextModal?.setMaskStyle({
                    background:
                        "linear-gradient(0deg, rgba(100, 40, 120, 0.20) 0%, rgba(100, 40, 120, 0.20) 100%), rgba(0, 0, 0, 0.65)",
                    // @ts-ignore
                    WebkitBackdropFilter: " blur(12px)",
                    backdropFilter: " blur(12px)"
                });
                contextModal?.setCssClass(" bl-modal-success-passport-add");
                contextModal?.setChildren(<SuccessAddPassport />);
                contextModal?.setVisible(true);
                contextModal?.setOnCancel(() => onCancelSign);
                // router.push(`/signature/${slug}/step4`);
            } else {
                contextModal?.setChildren(<Error />);
                contextModal?.setVisible(true);
                contextModal?.setOnCancel(() => onCancel);

                setLoading(false);
                setValue(0);
                setResponse(undefined);
                setIsLoaded(false);

                setTimeout(() => {
                    resize();
                });
            }
        }
    }, [isLoaded, response]);

    useEffect(() => {
        if (refResult.current) {
            const data = signaturePad.toDataURL();

            // const signaturePadResult = new SignaturePadResult(
            //   refResult.current,
            //   options
            // );
            // signaturePadResult.fromDataURL(data, {
            //   ratio: 1,
            //   width: 600,
            //   // height: 100,
            // });

            setTimeout(() => {
                // console.log(signaturePadResult.toDataURL());
                save(data, "signature.png", "image/png");
            }, 1000);
        }
    }, [refResult.current]);

    useEffect(() => {
        resize();
    }, [ref.current, width, signaturePad]);

    useLayoutEffect(() => {
        if (ref.current) {
            setSignaturePad(
                new SignaturePad(ref.current, {
                    backgroundColor: "transparent",
                    penColor: "rgb(0, 85, 255)"
                })
            );
        }
    }, [ref.current]);

    useEffect(() => {
        const f = async () => {
            try {
                // const res = await axios(
                //     `${process.env.REACT_APP_SITE_API_URL}/documents/phone-info/${params?.token}`,
                //     {
                //         headers: {
                //             Authorization: process.env.REACT_APP_SITE_BASIC_AUTH_HEADER!
                //         }
                //     }
                // );

                const response: any = await ReservationsService.getReservationsByPnone(
                    {
                        phone_number: +searchParams.get("phone")!,
                        status: _.isEqual(Store.reservations.activeKey, "activation")
                            ? "activated"
                            : ""
                    },
                    true
                );

                setPhoneInfo(_.get(response, "items[0].phone.abonentPassport"));
            } catch (e) {
                throw e;
            }
        };
        f();
    }, []);

    return (
        <Typography className="bl-signature-sign-page">
            <Typography className="container">
                {!loading ? (
                    <>
                        <Typography className="info">
                            <Typography className="title">
                                {`${
                                    _.isEqual(_.get(phoneInfo, "gender"), "w")
                                        ? "Уважаемая"
                                        : "Уважаемый"
                                } ${_.get(
                                    phoneInfo,
                                    "firstname",
                                    ""
                                )}, пожалуйста поставьте подпись для завершения процесса подписания договора об оказании услуг связи!`}
                            </Typography>
                            <Typography className="text">
                                {"ВНИМАНИЕ! \nПодпись должна совпадать \nс подписью в паспорте!"}
                            </Typography>
                        </Typography>

                        <Typography className="sign">
                            <canvas ref={ref} width={884} height={439} />
                        </Typography>

                        <Typography className="action">
                            <Button type="primary" onClick={onClick}>
                                Отправить
                            </Button>
                            <Button onClick={onClear}>Очистить</Button>
                        </Typography>
                    </>
                ) : (
                    <Typography className="loading-container">
                        <canvas ref={refResult} width={100} height={100} className="result" />
                        <LionProgressbar value={value} type="circle" progressColor="goldTexture" />
                        <Typography className="label">Идет загрузка...</Typography>
                    </Typography>
                )}
            </Typography>
        </Typography>
    );
});

export default Sign;
